import { DiaryFormOptionTranslation } from "./diary-form-option-translation.model";

export class DiaryFormOption {
  id: string;
  diaryFormElementId: string;
  text: string;
  translations: DiaryFormOptionTranslation[] = []
  orderIndex: number;
  deleted: boolean = false;
  deletedAt?: string;

  constructor(init?: Partial<DiaryFormOption>) {
    Object.assign(this, init);

    // Deep clone translations array
    if (init?.translations && init.translations.length > 0) {
      this.translations = init.translations.map(t => new DiaryFormOptionTranslation(t));
    }
  }
}
